import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class SessionStorageService {

  constructor() { }


  isJSON(str: any) {

    try {
      JSON.parse(str);
      return true;
    } catch (e) {
      return false;
    }
  }

  getKey(key: string) {

    if (window.sessionStorage[key]?.length) {
      return this.isJSON(window.sessionStorage[key]) ? JSON.parse(window.sessionStorage[key]) : window.sessionStorage[key]
    }
    return
  }

  saveKey(key: string, value: string | any) {
    window.sessionStorage[key] = value;
  }

  destroyKey(key: string) {
    window.sessionStorage.removeItem(key);
  }
}
